import React from 'react';
import Tools from '../../../Misc/Tools';
import { CoreDebugButtonType } from './core-controlled/debug/core-debug-dropdown-window';

import "./core-general-button4.css"

/*

EXAMPLE
<div style={{
				width: '300px',
				height: '100px'
			}} className="center-element">
				<CoreGeneralButton4 type={GeneralButton4Type.backgroundShutterInVertical} onClick={() => {
					alert('clicked')
				}} text="Some Content"></CoreGeneralButton4>
			</div> 

*/

const CoreGeneralButton4 = (props: GeneralButton4Config) => {
	return (
		<div className="core-general-button4" tabIndex={0} aria-label={props.ariaLabel} style={{
			width: '100%',
			height: '100%',
			// backgroundColor: props.isSelected ? 'gray' : undefined,
			pointerEvents: props.isDisabled ? 'none' : 'all',
			...props.style
		}} onKeyUp={Tools.mapDivEnterToClick} onClick={props.onClick}>
			<button className={"core-general-button4-single-button core-general-button4-" + props.type}>
				<span className=''>{props.text}</span>
			</button>
		</div>
	);

};

export interface GeneralButton4Config {
	type: GeneralButton4Type;
	onClick: () => void;
	text: string;
	ariaLabel?: string;
	style?: any;
	isSelected?: boolean;
	isDisabled?: boolean;
}

export enum GeneralButton4Type {
	backgroundFade = 'bg-fade',
	backgroundBackPulse = 'bg-back-pulse',
	backgroundSweepToRight = 'bg-sweep-to-right',
	backgroundSweepToLeft = 'bg-sweep-to-left',
	backgroundSweepToBottom = 'bg-sweep-to-bottom',
	backgroundSweepToTop = 'bg-sweep-to-top',
	backgroundBounceToRight = 'bg-bounce-to-right',
	backgroundBounceToLeft = 'bg-bounce-to-left',
	backgroundBounceToBottom = 'bg-bounce-to-bottom',
	backgroundBounceToTop = 'bg-bounce-to-top',
	backgroundRadialIn = 'bg-radial-in',
	backgroundRadialOut = 'bg-radial-out',
	backgroundRectangleIn = 'bg-rectangle-in',
	backgroundRectangleOut = 'bg-rectangle-out',
	backgroundShutterInHorizontal = 'bg-shutter-in-horizontal',
	backgroundShutterOutHorizontal = 'bg-shutter-out-horizontal',
	backgroundShutterInVertical = 'bg-shutter-in-vertical',
	backgroundShutterOutVertical = 'bg-shutter-out-vertical'
}

export default CoreGeneralButton4;

export const AllButton4Types: CoreDebugButtonType<GeneralButton4Type>[] = [
	{
		key: GeneralButton4Type.backgroundFade,
		value: 'GeneralButton4Type.backgroundFade'
	},
	{
		key: GeneralButton4Type.backgroundBackPulse,
		value: 'GeneralButton4Type.backgroundBackPulse'
	},
	{
		key: GeneralButton4Type.backgroundSweepToRight,
		value: 'GeneralButton4Type.backgroundSweepToRight'
	},
	{
		key: GeneralButton4Type.backgroundSweepToLeft,
		value: 'GeneralButton4Type.backgroundSweepToLeft'
	},
	{
		key: GeneralButton4Type.backgroundSweepToBottom,
		value: 'GeneralButton4Type.backgroundSweepToBottom'
	},
	{
		key: GeneralButton4Type.backgroundSweepToTop,
		value: 'GeneralButton4Type.backgroundSweepToTop'
	},
	{
		key: GeneralButton4Type.backgroundBounceToRight,
		value: 'GeneralButton4Type.backgroundBounceToRight'
	},
	{
		key: GeneralButton4Type.backgroundBounceToLeft,
		value: 'GeneralButton4Type.backgroundBounceToLeft'
	},
	{
		key: GeneralButton4Type.backgroundBounceToBottom,
		value: 'GeneralButton4Type.backgroundBounceToBottom'
	},
	{
		key: GeneralButton4Type.backgroundBounceToTop,
		value: 'GeneralButton4Type.backgroundBounceToTop'
	},
	{
		key: GeneralButton4Type.backgroundRadialIn,
		value: 'GeneralButton4Type.backgroundRadialIn'
	},
	{
		key: GeneralButton4Type.backgroundRadialOut,
		value: 'GeneralButton4Type.backgroundRadialOut'
	},
	{
		key: GeneralButton4Type.backgroundRectangleIn,
		value: 'GeneralButton4Type.backgroundRectangleIn'
	},
	{
		key: GeneralButton4Type.backgroundRectangleOut,
		value: 'GeneralButton4Type.backgroundRectangleOut'
	},
	{
		key: GeneralButton4Type.backgroundShutterInHorizontal,
		value: 'GeneralButton4Type.backgroundShutterInHorizontal'
	},
	{
		key: GeneralButton4Type.backgroundShutterOutHorizontal,
		value: 'GeneralButton4Type.backgroundShutterOutHorizontal'
	},
	{
		key: GeneralButton4Type.backgroundShutterInVertical,
		value: 'GeneralButton4Type.backgroundShutterInVertical'
	},
	{
		key: GeneralButton4Type.backgroundShutterOutVertical,
		value: 'GeneralButton4Type.backgroundShutterOutVertical'
	}
]